module.exports = __webpack_public_path__ + "img/RedReef.10b30a67.png";